import React, { useState } from 'react';
import headerImg from '../images/header2.png';
import { Formik } from 'formik';
import Thankyou from '../components/Thankyou';
import axios from 'axios';
import BeatLoader from 'react-spinners/BeatLoader';

const ShoreOpportunities = ({backHome}) => {

	const [upload_file, setUploadFile] = useState(null);
	const [thankyouPage, setThankyouPage] = useState(false);
	const [submitLoading, setSubmitLoading] = useState(false);

    return (
    <div className="h-screen">

	<nav className="flex items-center justify-between w-full absolute t-0 z-50 flex-wrap px-6 py-1">
        <div className="flex items-center flex-shrink-0 text-white mr-6 mt-4 ">
            <a href="http://hermesmaritime.com/">
            <span className="icon-hermes">
                <span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span><span className="path9"></span><span className="path10"></span><span className="path11"></span><span className="path12"></span><span className="path13"></span><span className="path14"></span><span className="path15"></span><span className="path16"></span></span>
            </a>
        </div>
        <div className="block lg:hidden">
            <button className="flex items-center px-3 py-2 border rounded text-teal-200 border-teal-400 hover:text-white hover:border-white">
            <svg className="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/></svg>
            </button>
        </div>
        <div className="w-full block flex-grow lg:flex lg:items-center lg:w-auto">
        </div>
	</nav>

	<div className="relative overflow-hidden bg-no-repeat bg-cover" style={{
    backgroundPosition: '50%',
    backgroundImage: `url(${headerImg}) `,
    height: `450px`
    }}>

        <div className="absolute top-0 right-0 bottom-0 left-0 w-full h-full overflow-hidden bg-fixed"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.25)' }}>
        <div className="flex justify-center items-center h-full">
            <div className="text-center text-white px-6 pt-12 md:px-12">
            <h1 className="text-5xl font-bold mt-0 mb-6">Shore Opportunities</h1>
            <h4 className="text-md mb-8 px-8">Hermes Ship Management offers maritime jobs onboard offshore DSV, AHTS, PSV & ROV support vessels including Tankers, Bulk carrier,Passenger, Container, General Cargo and other specialized Vessels, as well as shore side vacancies within the maritime sector.</h4>
                <a href="/" className="bg-transparent hover:bg-orange-500 text-orange-700 font-semibold hover:text-white py-2 px-4 border border-orange-500 hover:border-transparent rounded">
                Back to Home
                </a>
            </div>
        </div>
        </div>
    </div>

	{thankyouPage ?
	<div className="lg:px-48 items-center justify-center">
	<div className="w-full px-4 pt-10">

		<div>	
			<div className="py-10">	
				
				<Thankyou setThankyouPage={setThankyouPage} />
				
			</div>
		</div>
	</div>
	</div>
	:
	<Formik
	initialValues={{ 
		post_applied: '', 
		dateofavailability: '',
		indosno: '',
		name: '',
		email: '',
		dateofbirth: '',
		experience: '',
		contact_number: '',
		upload_cv: '',
		on_board_experince: '',
		about_yourself: '',
		terms: ''
	}}
	validate={values => {
		
		const errors = {};

		if (!values.email) {
		errors.email = 'This is a required field';
		} else if (
		!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
		) {
		errors.email = 'Invalid email address';
		}

		if(!values.post_applied)
		{
			errors.post_applied = 'This is a required field';
		}

		if(!values.dateofavailability) {
			errors.dateofavailability = 'This is a required field';
		}

		if(!values.indosno) {
			errors.indosno = 'This is a required field';
		}
		
		if(!values.name) {
			errors.name = 'This is a required field';
		}
		
		if(!values.dateofbirth) {
			errors.dateofbirth = 'This is a required field';
		}
		
		if(!values.contact_number){
			errors.contact_number = 'This is a required field';
		}
		
		if(!values.experience){
			errors.experience = 'This is a required field';
		}
		
		if(!values.upload_cv){
			errors.upload_cv = 'This is a required field';
		}

		if(values.terms.length == 0){
			errors.terms = 'Please accept terms of service'
		}

		return errors;
	}}
	onSubmit={(values, { setSubmitting, resetForm }) => {
		try{
		setSubmitLoading(true);
		const formData  = new FormData();
		if(values)
		{
		Object.keys(values).map((item, i) => {
			formData.append(item, values[item]);
		});
		}
		formData.append('file', upload_file);
		setTimeout(() => {
			let finalFormEndpoint = "https://goaship.com/admin/api/Shore";
			//let finalFormEndpoint = "http://localhost/cias/api/Shore";
			axios.post(finalFormEndpoint, formData)
			  .then(function (response) {
				setThankyouPage(true);
				resetForm(this.initialValues);
				setSubmitLoading(false);
			  })
			  .catch(function (error) {
				console.log(error);
			  });
			}, 400);
		}catch(e){
			console.log(e)
		}
	}}
	>
	{({
		values,
		errors,
		touched,
		handleChange,
		handleBlur,
		handleSubmit,
		setFieldValue,
		isSubmitting,
		/* and other goodies */
	}) => (
	<form onSubmit={handleSubmit}>
	<div className="lg:px-48 items-center justify-center">
		<div className="w-full px-4 pt-10">

			<div>	
				<div className="py-10">	
					<div>

						<div className="mb-5">
							<label for="post_applied" className="font-bold mb-1 text-sm text-gray-800 block">Post Applied For <span className="text-orange-500">*</span></label>
							<select placeholder='Select' name='post_applied' id="post_applied" onChange={handleChange} className={`w-full px-4 py-2 rounded-md border ${errors.post_applied && touched.post_applied && errors.post_applied ? 'border-red-500' : 'border-gray-500'}  shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm`}>
								<option value="">Select...</option>
								<option value="Master">Master</option>
								<option value="Chief Officer">Chief Officer</option>
								<option value="Second Officer">Second Officer</option>
								<option value="Third Officer">Third Officer</option>
								<option value="Jr. Officer">Jr. Officer</option>
								<option value="Chief Engineer">Chief Engineer</option>
								<option value="Second Engineer">Second Engineer</option>
								<option value="Third Engineer">Third Engineer</option>
								<option value="Fourth Engineer">Fourth Engineer</option>
								<option value="Electrical Officer">Electrical Officer</option>
								<option value="Jr. Engineer">Jr.Engineer</option>
								<option value="Able Seaman">Able Seaman</option>
								<option value="Oiler">Oiler</option>
								<option value="Deck Fitter">Deck Fitter</option>
								<option value="Engine Fitter">Engine Fitter</option>
								<option value="Wiper">Wiper</option>
								<option value="OS">OS</option>
								<option value="GS">GS</option>
								<option value="BOSUN">BOSUN</option>
								<option value="Cook">Cook</option>
								<option value="Deck Cadet">Deck Cadet</option>
							</select>
							<span class="text-sm text-red-600">{errors.post_applied && touched.post_applied && errors.post_applied}</span>
                        </div>

						<div className="flex gap-4">
							<div className="w-1/2">
								<div className="mb-5">
									<label for="dateofavailability" className="font-bold mb-1 text-sm text-gray-800 block">Date Of Availability <span className="text-orange-500">*</span></label>
									<input type="date" name='dateofavailability' id='dateofavailability'
										onChange={handleChange}
										onBlur={handleBlur}
										value={values.dateofavailability}
										className={`w-full px-4 py-2 rounded-md border ${errors.dateofavailability && touched.dateofavailability && errors.dateofavailability ? 'border-red-500' : 'border-gray-500'} shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm`}
										placeholder="Enter your date of birth..."/>
										<span class="text-sm text-red-600">{errors.dateofavailability && touched.dateofavailability && errors.dateofavailability}</span>
								</div>
							</div>
							<div className="w-1/2">
								<div className="mb-5">
									<label for="indosno" className="font-bold mb-1 text-sm text-gray-800 block">INDOS No. <span className="text-orange-500">*</span></label>
									<input type="text" name='indosno' id='indosno'
										onChange={handleChange}
										onBlur={handleBlur}
										value={values.indosno}
										className={`w-full px-4 py-2 rounded-md border ${errors.indosno && touched.indosno && errors.indosno ? 'border-red-500' : 'border-gray-500'} shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm`}
										placeholder="Enter INDOS Number..."/>
										<span class="text-sm text-red-600">{errors.indosno && touched.indosno && errors.indosno}</span>
								</div>
							</div>
						</div>
						
						<div className="flex gap-4">
                            <div className="w-1/2">
								<div className="mb-5">
									<label for="name" className="font-bold mb-1 text-sm text-gray-800 block">Name <span className="text-orange-500">*</span></label>
									<input type="text"
									onChange={handleChange}
									onBlur={handleBlur}
									value={values.name}
									name="name" id="name"
									className={`w-full px-4 py-2 rounded-md border ${errors.name && touched.name && errors.name ? 'border-red-500' : 'border-gray-500'} shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm`}
									placeholder="Enter your name..."/>
									<span class="text-sm text-red-600">{errors.name && touched.name && errors.name}</span>
								</div>
							</div>
							<div className="w-1/2">
								<div className="mb-5">
									<label for="dateofbirth" className="font-bold mb-1 text-sm text-gray-800 block">Date Of Birth <span className="text-orange-500">*</span></label>
									<input type="date"  name="dateofbirth" id="dateofbirth"
									onChange={handleChange}
									onBlur={handleBlur}
									value={values.dateofbirth}
									className={`w-full px-4 py-2 rounded-md border ${errors.dateofbirth && touched.dateofbirth && errors.dateofbirth ? 'border-red-500' : 'border-gray-500'} shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm`}
									placeholder="Enter your date of birth..."/>
									<span class="text-sm text-red-600">{errors.dateofbirth && touched.dateofbirth && errors.dateofbirth}</span>
								</div>
							</div>
						</div>

                        <div className="flex gap-4">
							<div className="w-1/2">
								<div className="mb-5">
									<label for="email" className="font-bold mb-1 text-sm text-gray-800 block">Email <span className="text-orange-500">*</span></label>
									<input type="email" name="email" id="email"
									onChange={handleChange}
									onBlur={handleBlur}
									value={values.email}
									className={`w-full px-4 py-2 rounded-md border ${errors.email && touched.email && errors.email ? 'border-red-500' : 'border-gray-500'} shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm`}
									placeholder="Enter your email..."/>
									<span class="text-sm text-red-600">{errors.email && touched.email && errors.email}</span>
								</div>
							</div>
							<div className="w-1/2">
								<div className="mb-5">
									<label for="contact_number" className="font-bold mb-1 text-sm text-gray-800 block">Contact Number <span className="text-orange-500">*</span></label>
									<input type="tel" name="contact_number" id="contact_number"
									onChange={handleChange}
									onBlur={handleBlur}
									value={values.contact_number}
									className={`w-full px-4 py-2 rounded-md border ${errors.contact_number && touched.contact_number && errors.contact_number ? 'border-red-500' : 'border-gray-500'} shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm`}
									placeholder="Enter your contact number..."/>
									<span class="text-sm text-red-600">{errors.contact_number && touched.contact_number && errors.contact_number}</span>
								</div>
							</div>
						</div>

                        <div className="flex gap-4">
							<div className="w-1/2">
								<div className="mb-5">
									<label for="experience" className="font-bold mb-1 text-sm text-gray-800 block">Experiance <span className="text-orange-500">*</span></label>
									<input type="text" name="experience" id="experience"
									onChange={handleChange}
									onBlur={handleBlur}
									value={values.experience}
										className={`w-full px-4 py-2 rounded-md shadow-sm border ${errors.experience && touched.experience && errors.experience ? 'border-red-500' : 'border-gray-500'} focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm`}
										placeholder="Enter your experience..."/>
									<span class="text-sm text-red-600">{errors.experience && touched.experience && errors.experience}</span>
								</div>
							</div>
							<div className="w-1/2">
								<div className="mb-5">
									<label for="board_experience" className="font-bold mb-1 text-sm text-gray-800 block">On Board Experiance(if any) </label>
									<input type="text" name='on_board_experince' id='on_board_experince'
									onChange={handleChange}
									onBlur={handleBlur}
									value={values.on_board_experince}
									className="w-full px-4 py-2 rounded-md shadow-sm border border-gray-500 focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
									placeholder="Enter your No. of children / Age..."/>
								</div>
							</div>
                        </div>

						<div className="flex gap-4">
							<div className="w-1/2">
                                <div className="mb-5">
                                    <label for="upload_cv" className="font-bold mb-1 text-sm text-gray-800 block">Upload CV <span className="text-orange-500">*</span></label>
                                    <input type="file" name="upload_cv" id="upload_cv"
									onChange={(event) => {
									handleChange(event);
									setUploadFile(event.currentTarget.files[0]);
									}}
									onBlur={handleBlur}
									value={values.upload_cv}
                                    className={`w-full px-2 py-1 bg-white rounded-md shadow-sm border ${errors.upload_cv && touched.upload_cv && errors.upload_cv ? 'border-red-500' : 'border-gray-500'} focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm`}
                                    placeholder="Choose file..."/>
									<span class="text-sm text-red-600">{errors.upload_cv && touched.upload_cv && errors.upload_cv}</span>
						        </div>
							</div>
							<div className="w-1/2">
								<div className="mb-5">
                                    <label for="about" className="font-bold mb-1 text-sm text-gray-800 block">Write About Yourself</label>
                                    <textarea name='about_yourself' id='about_yourself'
									onChange={handleChange}
									onBlur={handleBlur}
									value={values.about_yourself}
                                    className="w-full px-4 py-2 rounded-md border border-gray-500 shadow-sm focus:outline-none focus:shadow-outline text-gray-600 font-medium text-gray-800 text-sm"
                                    placeholder="Write about yourself..."></textarea>
                                </div>
							</div>
						</div>

						<div className="mb-5">
						<label className="flex justify-start items-center text-truncate pt-4">
						<div className="text-teal-600 mr-3">
							<input type="checkbox" 
							onChange={handleChange}
							onBlur={handleBlur}
							value="1" className="form-checkbox focus:outline-none focus:shadow-outline" name="terms" id='terms'/>
						</div>
						<div className="select-none text-gray-700">I accept the Terms of Service.</div>
						</label>
						<span class="text-sm text-red-600">{errors.terms && touched.terms && errors.terms}</span>
						</div>

					</div>
				</div>
			</div>
		</div>

		<div className=" bottom-0 left-0 right-0 py-5">
			<div className="max-w-3xl mx-auto px-4">
				<div className="flex justify-center">
						<button
							type="submit"
							disabled={submitLoading}
							className="w-32 focus:outline-none border border-transparent py-2 px-5 rounded-md shadow-sm text-center text-white bg-orange-500 hover:bg-orange-600 font-medium text-sm" 
						>{!submitLoading ? 'Submit' : <BeatLoader color='#fff' size={10} />}</button>
				</div>
			</div>
		</div>

	</div>
	</form>
	)}
	</Formik>
	}
    </div>
    )
}

export default ShoreOpportunities;